import { getKiosks } from '@frontend/shared/kiosk/data-access/src';
import { getSites } from '@frontend/shared/site/data-access/src';
import { getStaffs, Staff } from '@frontend/shared/staff/data-access';
import { createSelector } from '@ngrx/store';
import { getAppState } from 'apps/check-in-kiosk/src/app/reducers';

interface StaffWithFullName extends Staff {
  fullName: string;
}

export interface CheckInState {
  workflow_id: number;
  department_id: number;
  showAppointmentTime: boolean;
  showProvider: boolean;
  staff: StaffWithFullName[];
  timezone: string;
  loading: boolean;
}

export const getCheckInState = createSelector(
  getKiosks,
  getSites,
  getStaffs,
  getAppState,
  (kiosks: any[], sites: any[], staff: any[], app: any): CheckInState =>
    kiosks.map((kiosk) => ({
      workflow_id: app.workflow_id,
      department_id: kiosk.department_id,
      showAppointmentTime: kiosk.show_appointment_time,
      showProvider: kiosk.show_provider,
      staff: manipulateStaff(staff),
      timezone: sites.map((site) => site.default_timezone)[0],
      loading: app.loading,
    }))[0]
);

function manipulateStaff(staff: Staff[]): StaffWithFullName[] {
  return staff
    .map((s) => {
      const fullName = [s.last_name, s.first_name].filter((t) => !!t).join(', ');
      return { ...s, fullName };
    })
    .sort((a, b) => a.fullName.localeCompare(b.fullName));
}
